import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { PjSandboxView } from '../components/features/project/index.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PJ Sandbox ページ。PDG/ACE 各チームの白板上でブロック（開発/デザイン/バグ）を自由に配置し、将来の PJ 予定を模擬するプロジェクト管理フォルダ配下のサブページ。ガント×テトリス風の自由編集ボード
 * @graph-connects PjSandboxView [calls] PJ Sandbox ビュー描画
 */
export const Route = createFileRoute('/projects/pj-sandbox')({
  component: PjSandboxPage,
});

/** @graph-connects PjSandboxView [calls] PJ Sandbox ビュー描画 */
function PjSandboxPage() {
  return (
    <ProtectedRoute pageKey="pjSandbox">
      <PjSandboxView />
    </ProtectedRoute>
  );
}
